import { MapTo } from '@adobe/aem-react-editable-components';
import { FC } from 'react';
import { WithEmptyPlaceholder } from '../../../../lib/hoc/WithEmptyPlaceholder';
import MyCourses from './MyCourses';
import { CommonFilterViewProps } from '../../base/FilteredCardsView/FilteredCardsView.types';
import WithAuth from '../../../../lib/hoc/WithAuth/WithAuth';

const RESOURCE_TYPE = 'learning-academy/components/custom/mycourseslibrary';

const MyCoursesEmptyFn = (props: CommonFilterViewProps) => !props;

const EditConfig = {
  emptyLabel: 'My Courses',
  isEmpty: MyCoursesEmptyFn,
};

export default MapTo<CommonFilterViewProps>(RESOURCE_TYPE)(
  ...WithEmptyPlaceholder(WithAuth(MyCourses as FC<CommonFilterViewProps>), EditConfig),
);
